<template lang="html">
<section class="wcc header">
  <img src="@/assets/macdonald_realty_two_colour_logo.svg" alt="Madonald Realty Logo">
</section>
</template>
<script>
  export default {
  }
</script>
<style lang="scss">
  .wcc.header {
    padding: $spacing;
    img {
      display: block;
      margin: 0 auto;
      width: 40%;
      height: auto;
      max-width: 175px;
    }
    
  }
</style>